import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { DiscountPerWeek } from './DiscountPerWeek'

export const onEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.code === 'Enter') {
      callback(event)
    }
  }

type BlackFridayPromoBannerProps = {
  applyDiscount: () => void
  isHidden: boolean
}

export function BlackFridayPromoBanner({
  applyDiscount,
  isHidden,
}: React.PropsWithChildren<BlackFridayPromoBannerProps>) {
  if (isHidden) return null

  return (
    <Box
      alignItems={AlignItems.Center}
      onClick={applyDiscount}
      onKeyDown={onEnter(applyDiscount)}
      bg={Color.ColdGrey_900}
      color={Color.White}
      display={Display.Flex}
      justifyContent={[JustifyContent.Center]}
      paddingH={[4, null, 6, 8, 10]}
      paddingV={4}
      role="button"
      tabIndex={0}
      width="100%"
      aria-label="Apply Black Friday discount"
    >
      <Box flexGrow={1} />
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        gap={2}
      >
        <Body2 fontWeight={FontWeight.Bold} size={2} color={Color.White}>
          Black Friday sale now on<sup>**</sup>
        </Body2>
        <DiscountPerWeek />
      </Box>
      <Box flexGrow={1} />
      <Box>
        <Icon name="arrow_right" variant={IconVariant.Inherit} />
      </Box>
    </Box>
  )
}
